import { useLang } from "@/lib/i18n";
import StoryMedia from "./StoryMedia";

const COPY = {
  en: {
    eyebrow: "Since 2009",
    title: "Our Story",
    p: [
      "Our story began in Montréal in 2009 as Goon Entertainment, with a simple mission: give local artists a stage to share their talent and connect with fans and record labels. Through six editions of SHOW YOUR SKILLZ, we brought that mission to life, working alongside established artists and pioneers of Montréal’s urban music scene.",
      "In 2014, we opened The Recording Room, inspired by a need within our own community. Many artists and engineers from SHOW YOUR SKILLZ had the talent and vision, but needed a space to create.",
      "We built the studio around creative freedom. Our package-based approach gives artists room to develop their sound, bring an engineer who understands their vision, and work at their own pace within their booked sessions.",
      "Today, The Recording Room carries that same spirit forward: a private, comfortable space with a cozy atmosphere where creativity feels at home. More than a place to record, it’s a space you can make your own.",
    ],
  },
  fr: {
    eyebrow: "Depuis 2009",
    title: "Notre histoire",
    p: [
      "Notre histoire a commencé à Montréal en 2009 sous le nom de Goon Entertainment, avec une mission simple : offrir aux artistes d’ici une scène pour partager leur talent et se faire connaître du public et des maisons de disques. Au fil de six éditions de SHOW YOUR SKILLZ, nous avons donné vie à cette mission, aux côtés d’artistes établis et de pionniers de la scène musicale urbaine montréalaise.",
      "En 2014, nous avons ouvert The Recording Room pour répondre à un besoin de notre propre communauté. Plusieurs artistes et ingénieurs de son issus de SHOW YOUR SKILLZ avaient le talent et la vision, mais il leur manquait un espace pour créer.",
      "Nous avons bâti le studio autour de la liberté créative. Notre formule par forfaits permet aux artistes de développer leur son, d’amener un ingénieur qui comprend leur vision et de travailler à leur propre rythme pendant leurs sessions réservées.",
      "Aujourd’hui, The Recording Room perpétue ce même esprit : un espace privé et confortable, à l’ambiance chaleureuse, où la créativité se sent chez elle. Plus qu’un lieu d’enregistrement, c’est un espace que vous pouvez faire vôtre.",
    ],
  },
};

export default function OurStory() {
  const { lang } = useLang();
  const c = COPY[lang] || COPY.en;
  return (
    <section id="our-story" className="border-t border-white/5 bg-[#0c0d11]" data-testid="our-story-section">
      <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-10 lg:py-28">
      <div className="grid gap-10 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <p className="eyebrow mb-3" data-testid="our-story-eyebrow">{c.eyebrow}</p>
          <h2 className="font-display text-4xl uppercase text-white sm:text-5xl" data-testid="our-story-title">{c.title}</h2>
          <span className="mt-6 block h-px w-16 bg-red-600" />
        </div>
        <div className="space-y-6 lg:col-span-7 lg:col-start-6">
          {c.p.map((txt, i) => (
            <p key={i} className={`text-base leading-relaxed md:text-lg ${i === 0 ? "text-slate-200" : "text-slate-400"}`} data-testid={`our-story-p-${i}`}>{txt}</p>
          ))}
        </div>
      </div>
      <StoryMedia />
      </div>
    </section>
  );
}
